import { persistStore } from 'redux-persist';
import store from './store';

//@ts-expect-error I believe react-intl-redux types are not up to date to redux-toolkit >=2.0
//accordingly to redux-toolkit, from version 2.0, an Action 'type' has to be 'string'
//and IntlAction type is 'any'
export default persistStore(store);
